import React from 'react';
import { IMediaItem } from '../../lib';
import { WsrvImage } from "../Media/WsrvImage";
import { EWsrvTransform } from "../../lib/Media/util";
import Heading from "./Heading";

export interface IBladeColumnProps {
  columnImage: IMediaItem;
  header: string;
  titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  text: string;
}

export interface ISideBySideLayoutBladeProps {
  className?: string;
  leftColumn: IBladeColumnProps;
  rightColumn: IBladeColumnProps;
  rightColumnLarger?: boolean;
}

export const SideBySideLayoutBlade: React.FC<ISideBySideLayoutBladeProps> = ({
  leftColumn,
  rightColumn,
  rightColumnLarger = false,
  className = "",
}) => {

  return (
    <section
      className={`w-full flex flex-wrap md:flex-nowrap justify-center items-center gap-4 md:gap-8 xl:gap-14 ${className}`}
    >
      <article className={`w-full md:w-1/2 flex flex-col items-end`}>
        <div
          className={`max-w-full ${rightColumnLarger ? "lg:max-w-xl" : ""}`}
        >
          <WsrvImage
            urlParams={{
              originURL: leftColumn.columnImage.url,
              preset: EWsrvTransform.cover3x2,
            }}
            widthMax={rightColumnLarger ? 570 : 810}
            imgProps={{
              className: "max-w-full",
            }}
          />
        </div>
        <div className={`w-full max-w-xl`}>
          <Heading
            headingLevel={leftColumn.titleHeadingLevel || "h3"}
            className="py-5 text-2xl font-bold"
          >
            {leftColumn.header}
          </Heading>
          {leftColumn.text && (
            <div
              className="pb-5"
              dangerouslySetInnerHTML={{ __html: leftColumn.text }}
            ></div>
          )}
        </div>
      </article>
      <article className={`w-full md:w-1/2 flex flex-col items-start`}>
        <div
          className={`max-w-full ${rightColumnLarger ? "" : "lg:max-w-xl"}`}
        >
          <WsrvImage
            urlParams={{
              originURL: rightColumn.columnImage.url,
              preset: EWsrvTransform.cover3x2,
            }}
            widthMax={rightColumnLarger ? 810 : 570}
            imgProps={{
              className: "max-w-full",
            }}
          />
        </div>
        <div className={`w-full max-w-xl`}>
          <Heading
            headingLevel={rightColumn.titleHeadingLevel || "h3"}
            className="py-5 text-2xl font-bold"
          >
            {rightColumn.header}
          </Heading>
          {rightColumn.text && (
            <div
              className="pb-5"
              dangerouslySetInnerHTML={{ __html: rightColumn.text }}
            ></div>
          )}
        </div>
      </article>
    </section>
  );
};


export default SideBySideLayoutBlade;